import __request__ from "routing/request";
export function list(paginationparameters) {
  return __request__("GET", "/system/authentication/services/backends", paginationparameters, {}, {
    "Accept": ["application/json"]
  });
}
export function create(JSONbody) {
  return __request__("POST", "/system/authentication/services/backends", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function getActiveType() {
  return __request__("GET", "/system/authentication/services/backends/active-backend/type", null, {}, {
    "Accept": ["application/json"]
  });
}
export function get(backendId) {
  return __request__("GET", `/system/authentication/services/backends/${backendId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function update(backendId, JSONbody) {
  return __request__("PUT", `/system/authentication/services/backends/${backendId}`, JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function remove(backendId) {
  return __request__("DELETE", `/system/authentication/services/backends/${backendId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function getUsers(sort = "full_name", backendId, page = 1, per_page = 50, query, order = "asc") {
  return __request__("GET", `/system/authentication/services/backends/${backendId}/users`, null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  });
}
